<template>
<div id="contentWrap">
  <div class="content left">
    <div id="content_1block" class="left">
      <div class="response">
        <div class="response_icon left"><img src="../../assets/images/succesful_icon.png" width="42" height="42" alt="" /></div>
        <div class="response_block left linkfont">Congratulations! You have successfully registered. A validation email has been sent to <a href="javascript: void(0)">{{email}}</a>, please click the link in your email to activate your account. Thank you.
          <p>If you haven’t received the email , please click <a href="javascript: void(0)" @click="ResendMail()">here</a> to resend.</p>
        </div>
      </div>
      <div style="width: 200px; margin-left: auto; margin-right: auto;">
        <button class="button-warning pure-button " @click="back()">Back to Home</button>
      </div>
    </div>
  </div>
  <modal v-if="showModal" @close="showModal = false"/>
</div>
</template>
<script>
/*jshint esversion: 6 */
import router from '../../router.js';
import Modal from '../../tools/Modal';
export default {
  components: {
    Modal
  },
  data: function() {
    return {
      email: '',
      showModal: false
    };
  },
  methods: {
    ResendMail: function() {
      var url = sessionStorage.getItem('registerLink');
      // console.log(url);
      this.showModal = true;
      this.$http.get(url).then((response) => {
        // success callback
        var datums = response.data;
        if (datums > 0) {
          this.showModal = false;
        } else {

        }
      }, (response) => {
        // error callback
      });
    },
    back: function() {
      router.push('/');
    }
  },
  mounted(){
    this.email=sessionStorage.getItem('registerEmail');
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// RegisterResult.vue?f1e28ab6